import { render } from "./GKZL.vue?vue&type=template&id=0895e543&scoped=true"
import script from "./GKZL.vue?vue&type=script&lang=js"
export * from "./GKZL.vue?vue&type=script&lang=js"

import "./GKZL.vue?vue&type=style&index=0&id=0895e543&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0895e543"]])

export default __exports__